import Button from "@mui/material/Button";
import isFunction from "lodash/isFunction";
import isNil from "lodash/isNil";
import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useUnderwritingHook } from "../../../hooks/useUnderwritingHook";
import { loanDrilldownSet } from "../../../redux/actions/loanDrilldownActions";
import { loanPipelineClear } from "../../../redux/actions/loanPipelineActions";
import HtmlTextEditor from "../../inputs/HtmlTextEditor";
import Flx from "../../layout/Flx";
const onSuccessActionEnums = {
  LOAN_DRILLDOWN: "loanDrilldown",
  LOAN_PIPELINE: "loanPipeline",
};
const LoanCommentTextBox = ({
  loan,
  onSuccessfn,
  onSuccessAction,
  suppressFooterSpacing,
  sx,
}) => {
  const [comment, setComment] = useState(null);
  const { createDealComment, loading } = useUnderwritingHook();
  const dispatch = useDispatch();

  const showCommentFooter = useMemo(() => {
    if (isNil(comment)) {
      return false;
    }

    if (comment?.plainText?.trim()) {
      return true;
    }
    return false;
  }, [comment]);

  const onSubmit = () => {
    // console.log("Submitting comment:", {
    //   htmlString: comment?.htmlString,
    // });
    // return;
    createDealComment({
      loanId: loan?._id,
      data: {
        htmlString: comment?.htmlString,
      },
      onSuccessFn: (response) => {
        if (isFunction(onSuccessfn)) {
          onSuccessfn(response);
        }

        if (onSuccessAction === onSuccessActionEnums.LOAN_DRILLDOWN) {
          dispatch(loanDrilldownSet(response));
          return;
        }

        if (onSuccessAction === onSuccessActionEnums.LOAN_PIPELINE) {
          dispatch(loanPipelineClear(response));
          return;
        }

        dispatch(loanDrilldownSet(response));
        dispatch(loanPipelineClear(response));
        setComment("");
      },
    });
  };

  const styles = useMemo(() => {
    return {
      position: "relative",
      px: 1,
      ...sx,
    };
  }, [sx]);

  const footerStyles = useMemo(() => {
    if (suppressFooterSpacing) {
      return {};
    }
    return {
      pb: 2,
      mb: 2,
    };
  }, [suppressFooterSpacing]);

  return (
    <Flx column fw gap={1} sx={styles}>
      <HtmlTextEditor
        value={comment}
        onChange={setComment}
        placeholder="Start typing to add new comment..."
      />
      {showCommentFooter ? (
        <Flx wrap gap={1} end fw sx={footerStyles}>
          {/* <LoanAssociationOptions /> */}

          <Button loading={loading} onClick={onSubmit} size="small">
            Submit
          </Button>
        </Flx>
      ) : null}
    </Flx>
  );
};

export default LoanCommentTextBox;
